import Vue from "vue";
import store from "~/store";
import router from "~/router";
import i18n from "~/plugins/i18n";
import App from "~/components/App";
import { iconsSet as icons } from "~/assets/icons/icons.js";


import "~/components";
import "~/plugins";


Vue.config.productionTip = false;


/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  icons,
  ...App
});



